import { Poll } from '../interfaces';

export default (pollConfig: Poll): boolean => {
    return pollConfig.published === true;
};
